module.exports = __webpack_public_path__ + "static/media/patrol(18).dbf9afd1.PNG";